import React from 'react';

interface OrientationIconProps {
  side?: 'left' | 'right';
}

const OrientationIcon: React.FC<OrientationIconProps> = ({ side = 'left' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    style={{ transform: side === 'right' ? 'scaleX(-1)' : 'none' }}
  >
    <path
      fill="#262626"
      d="M8.623 11.607a1.246 1.246 0 0 1 0 1.786l-5.162 5.181c-.876.88-2.461.305-2.461-.892V7.318c0-1.197 1.585-1.772 2.461-.892l5.162 5.181ZM15.377 11.607a1.247 1.247 0 0 0 0 1.786l5.162 5.182c.85.851 2.362.339 2.456-.783l.005-.11h-1.064c0 .3-.396.443-.615.223l-5.163-5.182a.311.311 0 0 1 0-.446l5.163-5.182c.219-.22.615-.076.615.223H23l-.005-.11c-.09-1.086-1.511-1.6-2.372-.86l-.084.077-5.162 5.182Zm6.559 6.075H23V7.318h-1.064v10.364ZM12.75 3.313h-1.5V2h1.5v1.313Zm0 5.25h-1.5V5.937h1.5v2.625Zm0 5.25h-1.5v-2.626h1.5v2.626Zm0 5.25h-1.5v-2.625h1.5v2.625Zm0 3.937h-1.5v-1.313h1.5V23Z"
    />
  </svg>
);

export default OrientationIcon;
